var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4605 0.222656H6.22174C3.15943 0.222656 0.705078 2.72204 0.705078 5.76184V15.6243C0.705078 18.7091 3.20446 21.1635 6.24426 21.1635H24.4605C27.5453 21.1635 29.9997 18.6641 29.9997 15.6243V5.76184C29.9997 2.72204 27.5003 0.222656 24.4605 0.222656ZM11.4907 15.1965V6.18966L19.1915 10.6931L11.4907 15.1965Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.9e8e98d9046f9e71cbf669ee0bc6ac53.svg";
export { ForwardRef as ReactComponent };